import { connect } from "react-redux";
import { quiz4MetaWatch } from "../../actions/quiz4Actions";
import WatchMeta from "../quiz/WatchMeta";

const mapStateToProps = state => ({
  quizN: state.quiz4
});

export default connect(
  mapStateToProps,
  { quizNMetaWatch: quiz4MetaWatch }
)(WatchMeta);
